import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

// 订单列表
export function getOrdersList(data) {
  return Vue.axios({
    url: '/api/orders/list',
    method: 'get',
    params: {...data,}

  })
}

//post查询广告订单列表
export function queryOrdersList(data) {
  return Vue.axios({
    url: '/api/orders/queryList',
    method: 'post',
    data: {...data}
  })
}

//post查询广告精简订单列表
export function queryOrdersTiniList(data) {
  return Vue.axios({
    url: '/api/orders/queryTiniList',
    method: 'post',
    data
  })
}

//post查询全案营销的列表
export function queryWcmOrdersList(data) {
  return Vue.axios({
    url: '/api/orders/wcmList',
    method: 'post',
    data: {...data}
  })
}

//查询子订单
export function queryOrderChildren(parent_id, bool_undo = '', field = 'pid') {
  const data = {[field]: parent_id, bool_undo}
  return Vue.axios({
    url: '/api/orders/orderChildren',
    method: 'post',
    data
  })
}

// 删除订单文件
export function postOrdersFileDel(data) {
  return Vue.axios({
    url: '/api/orders/uploadDelete',
    method: 'get',
    params: {...data,}

  })
}

// 订单文件列表
export function postOrdersFileList(data) {
  return Vue.axios({
    url: '/api/orders/uploadList',
    method: 'get',
    params: {...data,}

  })
}

// 批量回款列表
export function getAccountList(data) {
  return Vue.axios({
    url: '/api/account/list',
    method: 'get',
    params: {...data,}

  })
}

// 回款详情
export function getAccountDetail(data) {
  return Vue.axios({
    url: '/api/account/detail',
    method: 'get',
    params: {...data,}
  })
}

// 批次回款保存
export function postAccountStore(data) {
  return Vue.axios({
    url: '/api/account/store',
    method: 'post',
    data: {...data,}

  })
}

// 批次回款保存
export function postAccountStoreBatch(data) {
  return Vue.axios({
    url: '/api/account/storeBatch',
    method: 'post',
    data: {...data,}
  })
}

// 执行记录列表
export function getOrdersListRecord(data) {
  return Vue.axios({
    url: '/api/orders/listRecord',
    method: 'get',
    params: {...data,}

  })
}

// 执行记录提交-作废
export function postOrdersStoreRecord(data) {
  return Vue.axios({
    url: '/api/orders/storeRecord',
    method: 'post',
    data: {...data,}

  })
}

// 检查订单是否重复创建
export function postOrdersVerifyUnique(data) {
  return Vue.axios({
    url: '/api/orders/verifyUnique',
    method: 'post',
    data: {...data,}
  })
}

//批量新建
export function postOrdersBatchCreate(data) {
  return Vue.axios({
    url: '/api/orders/batchCreate',
    method: 'post',
    data: {...data}
  })
}

// 订单撤回
export function getOrdersUndo(data) {
  return Vue.axios({
    url: '/api/orders/undo',
    method: 'get',
    params: {...data,}
  })
}

export function doOrdersRevokeUndo(data) {
  return Vue.axios({
    url: '/api/orders/revokeUndo',
    method: 'get',
    params: {...data,}
  })
}

// 订单删除
export function getOrdersDestroy(data) {
  return Vue.axios({
    url: '/api/orders/destroy',
    method: 'post',
    data: {...data,}
  })
}

// 发票申请
export function postInvoicesStore(data) {
  return Vue.axios({
    url: '/api/invoices/store',
    method: 'post',
    data: {invoice: data}
  })
}


// 执行||销售 状态步骤备注
export function stepRemark(data) {
  return Vue.axios({
    url: '/api/orders/stepRemark',
    method: 'post',
    data: {...data}
  })
}

export function savePublishLink(data) {
  return Vue.axios({
    url: '/api/orders/savePublishLink',
    method: 'post',
    data: {...data}
  })
}

// customerSaleForOrder
export function customerSaleForOrder(data) {
  return Vue.axios({
    url: '/api/customers/customerSaleForOrder',
    method: 'get',
    params: {...data,}
  })
}

// company options
export function getCompanyOptions() {
  return Vue.axios({
    url: '/api/company/options',
    method: 'post',
    data: {}
  })
}

// 合同列表
export function getContractList(data) {
  return Vue.axios({
    url: '/api/order_contract/list',
    method: 'post',
    data: {...data}
  })
}

// 合同列表-导出
export function exportContractList(data) {
  return postBlob('/api/order_contract/export', data)
}

// 合同附件列表
export function getContractAnnexList(data) {
  return Vue.axios({
    url: '/api/order_contract/annex_list',
    method: 'post',
    data: {...data}
  })
}

// 保存合同附件
export function saveContractAnnexes(data) {
  return Vue.axios({
    url: '/api/order_contract/save_annexes',
    method: 'post',
    data: {...data}
  })
}

// 删除合同附件
export function delContractAnnex(data) {
  return Vue.axios({
    url: '/api/order_contract/del_annex',
    method: 'post',
    data: {...data}
  })
}

// 订单合同归档记录
export function getOrderContractByOrderId(order_id) {
  return Vue.axios({
    url: '/api/order_contract/getListByOrderId',
    method: 'post',
    data: {order_id: order_id}
  })
}

//获取订单日志
export function getOrderLogs(data) {
  return Vue.axios({
    url: '/api/order/get_logs',
    method: 'get',
    params: {...data,}
  })
}

// 导出-营销订单导出
export function exportWcm(data) {
  return postBlob('/api/orders/exportWcm', data)
}

// 获取订单 pid is_mark
export function pidWithMark(params) {
  return Vue.axios({
    url: '/api/orders/pidWithMark',
    method: 'get',
    params
  })
}

// 获取目标项目
export function getAimProject(params) {
  return Vue.axios({
    url: '/api/orders/getAimProject',
    method: 'get',
    params
  })
}

// 转移子订单
export function transferChildOrders(data) {
  return Vue.axios({
    url: '/api/orders/transferChildOrders',
    method: 'post',
    data
  })
}

// 释放子订单
export function releaseChildOrders(data) {
  return Vue.axios({
    url: '/api/orders/releaseChildOrders',
    method: 'post',
    data
  })
}

// 追加子订单
export function appendChildOrders(data) {
  return Vue.axios({
    url: '/api/orders/appendChildOrders',
    method: 'post',
    data
  })
}

// 批量设置小组
export function transferOrganization(data) {
  return Vue.axios({
    url: '/api/orders/transferOrganization',
    method: 'post',
    data
  })
}

export function optionsUsers(params) {
  return Vue.axios({
    url: '/api/orders/optionsUsers',
    method: 'get',
    params
  })
}

// 保存整单业绩金额
export function saveMoneyAchievement(data) {
  return Vue.axios({
    url: '/api/orders/saveMoneyAchievement',
    method: 'post',
    data
  })
}

// 设置订单年框
export function setYearFrame(data) {
  return Vue.axios({
    url: '/api/order/set_year_frame',
    method: 'post',
    data
  })
}

/**
 * 标记返点
 * @param data
 * @returns {*}
 */
export function markRebate(data) {
  return Vue.axios({
    url: '/api/orders/markRebate',
    method: 'post',
    data
  })
}

/**
 * 核对返点
 * @param data
 * @return {*}
 */
export function verifyRebate(data) {
  return Vue.axios({
    url: '/api/orders/verifyRebate',
    method: 'post',
    data
  })
}

/**
 * 订单详情 精简版
 * @returns {*}
 * @param order_no
 * @param fields
 */
export function orderDetailTini(order_no, fields) {
  return Vue.axios({
    url: '/api/orders/detail_tini',
    method: 'post',
    data: {order_no, fields}
  })
}


/**
 * 同步主订单信息
 * @returns {*}
 * @param data
 */
export function syncMainInfo(data) {
  return Vue.axios({
    url: '/api/order/sync_main_info',
    method: 'get',
    params: {...data,}
  })
}

/**
 * 获取星象仪询单下拉列表
 * @returns {*}
 * @param data
 */
export function getIqIdOption(data) {
  return Vue.axios({
    url: '/api/orders/getIqIdOptions',
    method: 'get',
    params: {...data,}
  })
}

export function queryRecycleOrdersList(data) {
  return Vue.axios({
    url: '/api/orders/queryRecycleList',
    method: 'post',
    data: {...data}
  })
}
